import React, { useMemo } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes } from '@fortawesome/pro-light-svg-icons'

import { Table, Text } from '@domain-group/suit-theme'

import useCurrentUser from '@hooks/useCurrentUser'
import useSelector from '@hooks/useSelector'

import { TemplatePageCategoryModel } from '@models/types'

import type { EntitiesState } from '@redux/entities'

import Actions from '../Actions'

const buildColumns = (brands: EntitiesState['brands'], isBrandUser: boolean) => [
  {
    title: 'Title',
    dataKey: 'title',
    cellProps: {
      position: 'sticky',
      left: 0,
      width: 350,
    },
    render: (title: string) => <Text width={350} variant="ellipsis">{title}</Text>,
  },
  {
    title: 'Brand',
    dataKey: 'brand_id',
    render: (brand_id: number, templatePageCategory: TemplatePageCategoryModel) => (
      templatePageCategory.global ? 'All Brands' : brands[brand_id]?.title
    ),
  },
  {
    title: 'Global',
    dataKey: 'global',
    cellProps: {
      textAlign: 'center',
      width: 100,
    },
    render: (global: boolean) => (
      <FontAwesomeIcon icon={global ? faCheck : faTimes} />
    ),
  },
  {
    title: 'Allow Mix',
    dataKey: 'allow_category_mix',
    cellProps: {
      textAlign: 'center',
      width: 100,
    },
    render: (allow_category_mix: boolean) => (
      <FontAwesomeIcon icon={allow_category_mix ? faCheck : faTimes} />
    ),
  },
  {
    title: 'Actions',
    dataKey: 'longitude',
    cellProps: {
      textAlign: 'center',
      width: 100,
    },
    render: (id: number, item: TemplatePageCategoryModel) => {
      const { global } = item
      const renderActions = isBrandUser ? !global : true

      return renderActions && <Actions templatePageCategory={item} />
    },
  },
]

const TemplatePageCategoriesTable = (props: { templatePageCategories: TemplatePageCategoryModel[] }) => {
  const { templatePageCategories } = props

  const brands = useSelector(reduxState => reduxState.entities.brands)

  const currentUserPayload = useCurrentUser()
  const { isBrandUser } = currentUserPayload

  const memoColumns = useMemo(() => buildColumns(brands, isBrandUser), [templatePageCategories.length])

  return (
    <Table
      boxProps={{ border: 'none', maxHeight: 800, overflowY: 'auto' }}
      // @ts-expect-error TS2322
      columns={memoColumns}
      data={templatePageCategories}
      scroll={{ x: 800 }}
      stickyHeader
    />
  )
}

export default React.memo(TemplatePageCategoriesTable)
